import React from 'react';
import loadableVisibility from 'react-loadable-visibility/loadable-components';
import styled from '@emotion/styled';

import BelowTheFold from 'shared/components/BelowTheFoldControl';
import AnimatedLoader from 'shared/components/BelowTheFoldControl/AnimatedLoader';
import LoadableComponent from './Loadable';

const Loading = styled(AnimatedLoader)`
  height: 129px;
`;

const Loadable = loadableVisibility(
  () => import(/* webpackChunkName: "footer.lazy" */ './Loadable'),
  {
    fallback: <Loading className="client" />,
  }
);

interface Props {
  shouldLazyLoadSubComponent?: boolean;
}

const ServerOptimized = ({ shouldLazyLoadSubComponent = true }: Props) => {
  if (!shouldLazyLoadSubComponent) {
    return <LoadableComponent />;
  }

  return (
    <BelowTheFold
      render={Loadable}
      loading={() => <Loading />}
    />
  );
};

export default ServerOptimized;
